// © Microsoft Corporation. All rights reserved.

/**
 * An enumeration of all experiences ID.
 * By convention the experience ID ***MUST*** match exactly (including case) the class name for the experience.
 * NOTE: Keep this list alphabetical
 */
export enum ExperienceIds {
    animator = "Animator",
    articlePage = "ArticlePage",
    autosCard = "AutosCard",
    backgroundGradient = "BackgroundGradient",
    backgroundImageCommon = "BackgroundImageCommon",
    backgroundImageEdge = "BackgroundImageEdge",
    backgroundImageEdgeNext = "BackgroundImageEdgeNext",
    backgroundImageWC = "BackgroundImageWC",
    bannerManager = "BannerManager",
    baseHeader = "BaseHeader",
    bingAnswers = "BingAnswers",
    bingCards = "BingCardsExperience",
    bingHealth = "BingHealth",
    bingShopping = "BingShopping",
    bingShoppingLifestyleCard = "BingShoppingLifestyleCard",
    bingShoppingMeStripe = "BingShoppingMeStripe",
    bingMiniShopping = "BingMiniShopping",
    bingVideoCard = "BingVideoCard",
    bingWebSSO = "BingWebSSO",
    blowout = "Blowout",
    breakingNews = "BreakingNews",
    cardAction = "CardAction",
    cardActionV2 = "CardActionV2",
    coachmark = "Coachmark",
    coachmarkWC = "CoachmarkWC",
    coldStart = "ColdStart",
    coldStartUpsellCard = "ColdStartUpsellCard",
    clarity = "Clarity",
    comments = "Comments",
    commonHeader = "CommonHeader",
    complexContentPreview = "ComplexContentPreview",
    conditionalBanner = "ConditionalBanner",
    contentPreview = "ContentPreview",
    contentProvider = "ContentProvider",
    contentRelated = "ContentRelated",
    contentActionsToolbar = "ContentActionsToolbar",
    contentSharingToolbar = "ContentSharingToolbar",
    cookieWall = "CookieWall",
    covidChatBot = "CovidChatBot",
    dailyBrief = "DailyBrief",
    dashboardSettings = "DashboardSettings",
    desktopFeed = "DesktopFeed",
    desktopFeedEdgeNext = "DesktopFeedEdgeNext",
    desktopFeedSingleColumn = "DesktopFeedSingleColumn",
    displayAds = "DisplayAds",
    displayAdsWC = "DisplayAdsWC",
    displayAdsWithContentFallback = "DisplayAdsWithContentFallback",
    edgeChromiumPage = "EdgeChromiumPage",
    edgeHeader = "EdgeHeader",
    edgeNextPage = "EdgeNextPage",
    edgePage = "EdgePage",
    edgePageSettings = "PageSettings",
    editorsChoicePromoCard = "EditorsChoicePromoCard",
    electionDelegateCounter = "ElectionDelegateCounter",
    electionEditorsNote = "ElectionEditorsNote",
    electionResultMap = "ElectionResultMap",
    electionResultsCard = "ElectionResultsCard",
    electionVisualizer = "ElectionVisualizer",
    enterpriseComplianceBanner = "EnterpriseComplianceBanner",
    enterpriseFeedContainer = "EnterpriseFeedContainer",
    enterpriseRightRail = "EnterpriseRightRail",
    enterpriseWaffle = "EnterpriseWaffle",
    entryPoint = "EntryPoint",
    entryPointEdgeNext = "EntryPointEdgeNext",
    entryPointOffice = "EntryPointOffice",
    eventHubHeroNav = "EventHubHeroNav",
    eventHubPage = "EventHubPage",
    externalContentPreview = "ExternalContentPreview",
    externalNativeAd = "ExternalNativeAd",
    feedToggle = "FeedToggle",
    feedToggleWC = "FeedToggleWC",
    feedVisualizer = "FeedVisualizer",
    financeCurrencyConverter = "FinanceCurrencyConverter",
    financePage = "FinancePage",
    firstPartyPage = "FirstPartyPage",
    flyoutCard = "FlyoutCard",
    feedbackDialog = "FeedbackDialog",
    feedbackLink = "FeedbackLink",
    feedEdgeNext = "FeedEdgeNext",
    financeCardCommon = "FinanceCardCommon",
    financeCompanyProfileCard = "FinanceCompanyProfileCard",
    financeDetailHeader = "FinanceDetailHeader",
    financeDetailNavigation = "FinanceDetailNavigation",
    financeDetailPage = "FinanceDetailPage",
    financeDetailPageV2 = "FinanceDetailPageV2",
    financeFeeds= "FinanceFeeds",
    financeFinancialsCard = "FinanceFinancialsCard",
    financeLandingPageV2 = "FinanceLandingPageV2",
    financeMarketCard = "FinanceMarketCard",
    financeMarketStatus = "FinanceMarketStatus",
    financeNewsCard = "FinanceNewsCard",
    financeNewsContent = "FinanceNewsContent",
    financeDetailsCard = "FinanceDetailsCard",
    financeIndicesCard = "FinanceIndicesCard",
    financeMarketMoversCard = "FinanceMarketMoversCard",
    financeRecentlyViewedCard = "FinanceRecentlyViewedCard",
    financeRecommendationCard = "FinanceRecommendationCard",
    financeRecommendationCardV2 = "FinanceRecommendationCardV2",
    financeWatchlistCard = "FinanceWatchlistCard",
    financeWatchlistPage = "FinanceWatchlistPage",
    financeSearchBox = "FinanceSearchBox",
    financeTrendCard = "FinanceTrendCard",
    footerWindowsShell = "FooterWindowsShell",
    freMarketSelector = "FreMarketSelector",
    frequentSitesCard = "FrequentSitesCard",
    frequentSitesCardWC = "FrequentSitesCardWC",
    galleryPage = "GalleryPage",
    generalElections = "GeneralElections",
    gmailEmailPreview = "GmailEmailPreview",
    headerEdgeNext = "HeaderEdgeNext",
    headerNavigationLogo = "HeaderNavigationLogo",
    headerWindowsShell = "HeaderWindowsShell",
    hiddenContent = "HiddenContent",
    homePage = "HomePage",
    horoscopeAnswerCard = "HoroscopeAnswerCard",
    horoscopeAnswerCardWC = "HoroscopeAnswerCardWC",
    iframe = "IFrame",
    imageSearch = "ImageSearch",
    industryNewsCard = "IndustryNewsCard",
    infopane = "Infopane",
    interests = "Interests",
    interestsLeftRail = "InterestsLeftRail",
    interestsSearch = "InterestsSearch",
    interestsV1Wrapper = "InterestsV1Wrapper",
    interestsV2 = "InterestsV2",
    interestsV3 = "InterestsV3",
    languageToggle = "LanguageToggle",
    layoutSwitcher = "LayoutSwitcher",
    legacySharingToolbar = "LegacySharingToolbar",
    localNews = "LocalNews",
    localNewsViewCard = "LocalNewsViewCard",
    locationContentCard = "LocationContentCard",
    locationSelector = "LocationSelector",
    locationTime = "LocationTime",
    marketAggregator = "MarketAggregator",
    marketSelector = "MarketSelector",
    meControl = "MeControl",
    meStripe = "MeStripe",
    meetNow = "MeetNow",
    microsoftLogo = "MicrosoftLogo",
    microsoftNewsPage = "MicrosoftNewsPage",
    migrationConsent = "MigrationConsent",
    miniApps = "miniApps",
    mmxPage = "MMXPage",
    mnsCreatorDashboard = "MnsCreatorDashboard",
    modernRightRail = "ModernRightRail",
    moneyCard = "MoneyCard",
    moneyInfoCard= "MoneyInfoCard",
    mobileFeed = "MobileFeed",
    msnSettingMenu = "MsnSettingMenu",
    msRewards = "MsRewards",
    msRewardsWC = "MsRewardsWC",
    myBriefRiverCard = "MyBriefRiverCard",
    nativeAd = "NativeAd",
    newsbarFeed = "NewsbarFeed",
    notificationBell = "NotificationBell",
    ocvFeedbackData = "OcvFeedbackData",
    office = "Office",
    officeContainer = "OfficeContainer",
    officeDocumentCard = "OfficeDocumentCard",
    officeDocumentsTable = "OfficeDocumentsTable",
    officeLeftRail = "OfficeLeftRail",
    oneFooter = "OneFooter",
    overlay = "Overlay",
    outlookEmailPreview = "OutlookEmailPreview",
    onThisDayCard = "OnThisDayCard",
    onThisDayCardWC = "OnThisDayCardWC",
    pageRefresh = "PageRefresh",
    partnerWidget = "PartnerWidget",
    photoCard = "PhotoCard",
    pivotContent = "PivotContent",
    pivotContentV2 = "PivotContentV2",
    pivotHover = "PivotHover",
    pivotsNav = "PivotsNav",
    pivotsNavV2 = "PivotsNavV2",
    pollsCard = "PollsCard",
    portugueseElectionExperience = "PortugueseElectionExperience",
    poweredByLegend = "PoweredbyLegend",
    proactiveCanvas = "ProactiveCanvas",
    productivityHubContainer = "ProductivityHubContainer",
    promoBanner = "PromoBanner",
    publishersManagement = "PublishersManagement",
    qnaFeedCard="QnaFeedCard",
    qnaFeedCategoriesMenu="QnaFeedCategoriesMenu",
    qnaFeedList="QnaFeedList",
    qnaFeedSuggestedTopics="QnaFeedSuggestedTopics",
    qnaFeedTopicDetail="QnaFeedTopicDetail",
    recipesCards = "RecipesCards",
    recipesFeed = "RecipesFeed",
    recipesSearch = "RecipesSearch",
    recipesSingleDetail = "RecipesSingleDetail",
    recipesSingleVideo = "RecipesSingleVideo",
    recommendedCard = "RecommendedCard",
    recommendedCardWC = "RecommendedCardWC",
    recommendedCardFeed = "RecommendedCardFeed",
    recommendedDocuments = "RecommendedDocuments",
    recommendedSearch = "RecommendedSearch",
    recommendedSearchBelowSearchBox = "RecommendedSearchBelowSearchBox",
    recommendedSearchCarousel = "RecommendedSearchCarousel",
    recommendedSearchCarouselWC = "RecommendedSearchCarouselWC",
    recommendedSites = "RecommendedSites",
    recommendedTopics = "RecommendedTopics",
    relatedArticleBlock = "RelatedArticleBlock",
    relatedSearchesCard = "RelatedSearchesCard",
    rightRail = "RightRail",
    rightRailCards = "RightRailCards",
    rightRailCarousel = "RightRailCarousel",
    river = "River",
    riverPlaceholder = "RiverPlaceholder",
    searchBoxCommon = "SearchBoxCommon",
    searchBoxEdge = "SearchBoxEdge",
    searchBoxEdgeNext = "SearchBoxEdgeNext",
    searchBoxEdgeNextWC = "SearchBoxEdgeNextWC",
    searchHistoryCommon = "SearchHistoryCommon",
    searchHistoryEdge = "SearchHistoryEdge",
    searchHistoryEdgenext = "SearchHistoryEdgenext",
    seeMoreButtonWindowsShell = "SeeMoreButtonWindowsShell",
    sentimentBarChart = "SentimentBarChart",
    sentimentLineChart = "SentimentLineChart",
    sentimentMap = "SentimentMap",
    sentimentResultCard = "SentimentResultCard",
    serviceWaffle = "ServiceWaffle",
    settingsDialogEdgeNext = "SettingsDialogEdgeNext",
    settingsDialogMsNews = "SettingsDialogMsNews",
    sharedLinksCard = "SharedLinksCard",
    sharedState = "SharedState",
    sharePointSitesTable= "SharePointSitesTable",
    shopContentCarousel = "ShopContentCarousel",
    shoppingCarousel = "ShoppingCarousel",
    shoppingContentCard = "ShoppingContentCard",
    shoppingSmartList = "ShoppingSmartList",
    showFeed = "ShowFeed",
    showFeedPill = "ShowFeedPill",
    simpleBanner = "SimpleBanner",
    slideShow = "SlideShow",
    smartList = "SmartList",
    social = "Social",
    sportsCard = "SportsCard",
    sportsMatchupCard = "SportsMatchupCard",
    spotlight = "Spotlight",
    spotlightPreview = "SpotlightPreview",
    starterKit = "StarterKit",
    starterKitWC = "StarterKitWC",
    storyPage = "StoryPage",
    storySnippet = "StorySnippet",
    stripe = "Stripe",
    stripeFeed = "StripeFeed",
    stripeView = "StripeView",
    summaryCard = "SummaryCard",
    summaryCardWC = "SummaryCardWC",
    superAppPage = "SuperAppHomepage",
    superappHeaderData = "SuperappHeaderData",
    tabbedInfopane = "TabbedInfopane",
    tabbedInfopaneTabPreview = "TabbedInfopaneTabPreview",
    taboolaRiver = "TaboolaRiver",
    tasksCard = "TasksCard",
    themePicker = "ThemePicker",
    themePickerWC = "ThemePickerWC",
    toast = "Toast",
    todaysEventsCard = "TodaysEventsCard",
    todaysEventsCardWC = "TodaysEventsCardWC",
    todoCard = "TodoCard",
    todoCardWC = "TodoCardWC",
    topicsHub = "TopicsHub",
    topSites = "TopSites",
    topSitesCommon = "TopSitesCommon",
    topSitesEdge = "TopSitesEdge",
    topSitesEdgeNext = "TopSitesEdgeNext",
    topSitesEdgeNextWC = "TopSitesEdgeNextWC",
    trafficCard = "TrafficCard",
    trafficCardWC = "TrafficCardWC",
    trafficMap = "TrafficMap",
    trafficPage = "TrafficPage",
    trendingNews = "TrendingNews",
    trendingNow = "TrendingNow",
    tripleCard = "TripleCard",
    userInitiatedPageRefresh = "UserInitiatedPageRefresh",
    userProfileDisplay = "UserProfileDisplay",
    verticalLeftNav ="VerticalLeftNav",
    videoCard = "VideoCard",
    videoCardWC = "VideoCardWC",
    videoContent = "VideoContent",
    videoList = "VideoList",
    viewsArticle = "ViewsArticle",
    viewsContentHeader = "ViewsContentHeader",
    viewsGallery = "ViewsGallery",
    viewsNativeAd = "ViewsNativeAd",
    viewsPaddles = "ViewsPaddles",
    voiceSearch = "VoiceSearch",
    watchlistCard = "WatchlistCard",
    watchlistView = "WatchlistView",
    weatherCard = "WeatherCard",
    weatherCarousel = "WeatherCarousel",
    weatherData = "WeatherData",
    weatherLocationSearch = "WeatherLocationSearch",
    weatherMap = "WeatherMap",
    weatherOverview = "WeatherOverview",
    weatherPage = "WeatherPage",
    weatherInfoCard = "WeatherInfoCard",
    weatherToast = "WeatherToast",
    weatherTodayCard = "WeatherTodayCard",
    weatherTodayMini = "WeatherTodayMini",
    welcomeGreeting = "WelcomeGreeting",
    windowsPage = "WindowsPage",
    ugcCreator = "UgcCreator",
    xfeed = "Xfeed"
}
